import React, { useEffect, useState } from 'react';
import { postGoogleOauthCallback } from "api";
import { Navigate, useSearchParams, useNavigate } from 'react-router-dom';
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';
import { getUrlToLoginCallbackPage, getUrlToLoginPage } from 'pages/urls';
import { saveUserToken } from 'api/auth-storage';
import { HttpApiResponseError } from 'shared/http-api';
import { Link } from 'react-router-dom';

export function GoogleLoginCallbackPage () {
  const navigate = useNavigate();
  const [urlSearchParams] = useSearchParams();
  const [callbackError, setCallbackError] = useState<string|undefined>();
  const scope = urlSearchParams.get('scope') || undefined;
  const code = urlSearchParams.get('code') || undefined;
  const error = urlSearchParams.get('error') || undefined;
  const state = urlSearchParams.get('state') || undefined;

  useEffect(() => {
    if (!code) return;
    const handleCallback = async () => {
      try {
        const { tokenInfo, state: decodedState } = await postGoogleOauthCallback({ scope, code, error, state });
        saveUserToken(tokenInfo);
        const searchParams = new URLSearchParams(decodedState);
        navigate(getUrlToLoginCallbackPage() + '?' + searchParams.toString());
      } catch (e) {
        if (e instanceof HttpApiResponseError) {
          const body = await e.json()
          setCallbackError(body.message || 'Unknown Error Occurred');
        } else {
          setCallbackError('Unknown Error Occurred');
        }
      }
    };
    handleCallback();
  }, [scope, code, error, state]);

  if (callbackError) {
    return (
      <div className='text-center pt-10'>
        <h1 className='text-xl my-2'>Oops!</h1>
        <p>{callbackError}</p>
        <p className='text-violet-600'><Link to={getUrlToLoginPage()}>Click here to go back</Link></p>
      </div>
    )
  }

  if (!code) {
    return (
      <Navigate to={getUrlToLoginPage()} />
    );
  }

  return (
    <SpinnerFullPage />
  );
}
